import { z } from 'zod';
import * as FlatModels from '../../internal';

export const nodeMapSchema = z.object({
	id: z.string().uuid(),
	parentId: z.string().uuid(),
	allowedUserIds: z.set(z.string().uuid())
});

export type nodeMap = z.infer<typeof nodeMapSchema>;

export const AclResponseSchema = z.object({
	parentId: z.string().uuid().optional(),
	pageId: z.string().uuid().optional(),
	nodes: z.map(z.string(), nodeMapSchema).optional(),
	combinedAllowedUserIds: z.set(z.string().uuid())
});

export type AclResponse = z.infer<typeof AclResponseSchema>;

export const AclRoleAccessSchema = z.object({
	full: z.array(FlatModels.UserEntityModels.Role).optional(),
	item: z.array(FlatModels.UserEntityModels.Role).optional()
});

export type AclRoleAccess = z.infer<typeof AclRoleAccessSchema>;

export const AclMapSchema = z.map(z.string(), AclResponseSchema);

export type AclMap = z.infer<typeof AclMapSchema>;

export const AclResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
	entity: z.object({
		id: z.string().uuid(),
		acl: z.boolean(),
	})
});

export type AclResult = z.infer<typeof AclResultSchema>;

export const NodeAclSchema = z.record(z.string().uuid(), z.boolean());

export type NodeAcl = z.infer<typeof NodeAclSchema>;
